import clsx from 'clsx'

export type StatusPillStatus = 'live' | 'draft' | 'error'

export interface StatusPillProps {
  status: StatusPillStatus
  label: string
}

const STATUS_CLASSES: Record<StatusPillStatus, string> = {
  live: 'bg-success/20 text-success',
  draft: 'bg-warning/20 text-warning',
  error: 'bg-danger/20 text-danger',
}

// Colour + text, never colour alone - PRD 01's own accessibility acceptance
// criterion, so `label` is required (no icon-only/colour-only variant).
export function StatusPill({ status, label }: StatusPillProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-pill px-2 py-1 text-meta font-medium',
        STATUS_CLASSES[status],
      )}
    >
      {label}
    </span>
  )
}
